import {
  Button,
  Stack,
  Typography,
  Box,
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { toast } from 'react-toastify';
import { Icon } from '@/units/index';
import { useNotesContext } from '../../hooks/useNotesContext';
import PublicAPI from '@/api/TreedisPublicDAO';
import socket from '@/components/util/socket';
import { useNotesStore } from '../../stores/notes.store';

type Props = {
  setIsLoading: (value: boolean) => void;
};

export function DeleteReplyModal({ setIsLoading }: Props) {
  const { currentAction, setCurrentAction, setMediaUrls, setNoteToEdit } = useNotesContext();

  const { deleteMessage } = useNotesStore((state) => state.actions);

  const isOpen =
    !!currentAction &&
    currentAction.type === 'delete' &&
    !!currentAction.message &&
    !currentAction.message.isMainMessage;

  return (
    <Dialog
      open={isOpen}
      onClose={() => setCurrentAction(null)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-paper': { background: 'transparent', borderRadius: '12px' },
        '& .MuiBackdrop-root': {
          background: 'rgba(0, 0, 0, 0.40)',
          backdropFilter: 'blur(8px)',
        },
      }}
    >
      <Stack sx={{ maxWidth: '400px', background: 'white', borderRadius: '12px' }}>
        <DialogContent>
          <Box display="flex" alignItems="start" justifyContent="flex-start" paddingBottom={2}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                background: '#FEF3F2',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '35px',
                  height: '35px',
                  borderRadius: '50%',
                  background: '#FEE4E2',
                }}
              >
                <Icon.Delete style={{ color: 'transparent', fontSize: 20 }} />
              </Box>
            </Box>
          </Box>
          <Typography variant="h6" align="left">
            Delete this reply?
          </Typography>
          <Typography align="left" sx={{ color: '#667085', fontSize: '14px', fontWeight: '400' }}>
            Are you sure you want to delete this reply? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="space-between"
            width="100%"
            padding={2}
          >
            <Button
              variant="outlined"
              onClick={() => setCurrentAction(null)}
              style={{
                color: '#344054',
                flex: 1,
                marginRight: 12,
                border: '1px solid #D0D5DD',
                borderRadius: 8,
                height: 48,
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={async () => {
                if (!currentAction?.message) {
                  toast.error('Could not delete message');
                  return;
                }
                setIsLoading(true);

                const { message: messageToDelete } = currentAction;

                const result = await PublicAPI.deleteThreadMessage({
                  data: { messageId: messageToDelete.id },
                });

                if (result?.message === 'Success') {
                  toast.error('Message deleted');
                  socket.emit('message_deleted', {
                    id: messageToDelete.id,
                    threadId: messageToDelete.threadId,
                    userId: messageToDelete.userId,
                  });
                }

                deleteMessage(messageToDelete.threadId, messageToDelete.id);

                setNoteToEdit(null);
                setMediaUrls([]);
                setIsLoading(false);

                currentAction?.onSuccess?.();
                setCurrentAction(null);
              }}
              color="primary"
              style={{
                flex: 1,
                marginLeft: 12,
                borderRadius: 8,
                height: 48,
                background: '#D92D20',
              }}
            >
              Delete
            </Button>
          </Stack>
        </DialogActions>
      </Stack>
    </Dialog>
  );
}
